export enum StudentRank {
  lieutenant = 'lieutenant',
  secondLieutenant = 'second_lieutenant',
  captain = 'captain',
  major = 'major',
  lieutenantColonel = 'lieutenant_colonel',
  colonel = 'colonel',
  civilian = 'civilian',
}
